export default __webpack_public_path__ + "static/media/BusTraveling.dada5fab.svg";